import * as types from './types';
import * as api from './api';
import { createFiltersActions } from '../../common/filters/actions';

export default createFiltersActions(types, api);
